module.exports = __webpack_public_path__ + "static/media/night_flight_2.5f8f22fc.jpg";